import { QConfigProvider } from '@exam-management/feature-qconfig-provider';
import {
  type PermissionRouteGuardData,
  PermissionRouteGuard,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QConfigDetailHeader } from '@exam-management/qconfig-detail';
import { useParams } from '@exam-management/router';
import { Outlet } from 'react-router-dom';

export default function QConfigDetailsLayout() {
  const { courseId, qconfigId } = useParams('/exam-courses/:courseId/qconfigs/:qconfigId');

  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/exam-courses/:courseId/qconfigs/:qconfigId',
      requiredPermission: [APP_PERMISSIONS.EXAM.QCONFIG.VIEW, APP_PERMISSIONS.EXAM.AUDIT_LOG.VIEW],
      params: { courseId, qconfigId },
    },
    {
      path: '/exam-courses/:courseId/qconfigs/:qconfigId/details',
      requiredPermission: [APP_PERMISSIONS.EXAM.QCONFIG.VIEW],
      params: { courseId, qconfigId },
    },
    {
      path: '/exam-courses/:courseId/qconfigs/:qconfigId/settings',
      requiredPermission: [APP_PERMISSIONS.EXAM.QCONFIG.VIEW],
      params: { courseId, qconfigId },
    },
    {
      path: '/exam-courses/:courseId/qconfigs/:qconfigId/activity-log',
      requiredPermission: [APP_PERMISSIONS.EXAM.AUDIT_LOG.VIEW],
      params: { courseId, qconfigId },
    },
  ];

  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <QConfigProvider courseId={courseId} qconfigId={qconfigId}>
        <QConfigDetailHeader />
        <Outlet />
      </QConfigProvider>
    </PermissionRouteGuard>
  );
}
